import styled from "styled-components";
import FacebookLogin from "react-facebook-login";
import { useSelector } from "react-redux";
// import facebook from "../../../../assets/images/facebook-icon.svg";
import { StyleFacebookButton } from "../../Customization/CommonElements";
import { useAppDispatch } from "../../Store";
import { useNotification } from "../../Hooks/useNotification/useNotification";
import { FacebookSettingsActions } from "../../Store/Slices/Settings/facebookSettings/facebookSettings.actions";
interface Props {
  componentClicked: any;
  hideLogo?: boolean;
}

const FacebookIntegration: React.FC<any> = ({
  
}) => {
    const dispatch = useAppDispatch();
  let { showAlert } = useNotification();
  // const currentBot = useSelector(useCurrentBot);
  const componentClicked = (response: any) => {
    console.log("response",response);
    if (response.accessToken && !response?.error?.code) {
      const data_for_config = {
        access_token: response.accessToken,
      };
      console.log("response", response);
      console.log(data_for_config, "data_for_config");
    //   setLoading(true);
      dispatch(
        FacebookSettingsActions.facebookConfigData(data_for_config),
      ).then((save_result: any) => {
        showAlert("Connected to Facebook successfully!", "success");
        // getConfigPageList();
      });
    }
  };
  var exchange_token = "";
  var facebook_response = "";
  var facebook_exchange_token = "";

  const responseFacebook = (response: any) => {
    facebook_response = response;
    facebook_exchange_token = response.accessToken;
  };
  return (
    <FacebookPageWrap>
      <div className="pageTopbar">
        {/* <AppIcon title={'ri-arrow-left-line'} size="26px" color="#282828" /> */}
      </div>
      <div className="ctaBox">
        {/* {!hideLogo ? ( */}
        <>
          {/* <img className="companyLogo" src={facebook} alt="" /> */}
          <p className="ctaTitle">Connect with Facebook Account</p>
        </>
        {/* ) : (
          <></>
        )} */}

        <FacebookLogin
          class="fbLeadForm"
          appId={process.env.REACT_APP_FACEBOOK_APP_ID}
          autoLoad={false}
          fields="name,email,picture"
          xfbml={true}
        //   oldscope="manage_pages,pages_messaging,pages_messaging_subscriptions,read_page_mailboxes,ads_management,leads_retrieval,pages_manage_ads,pages_read_engagement,pages_show_list,pages_manage_metadata,business_management,pages_manage_engagement"
          scope="manage_pages,pages_messaging,pages_messaging_subscriptions,ads_management,leads_retrieval,pages_manage_ads,pages_read_engagement,pages_show_list,pages_manage_metadata,business_management,pages_manage_engagement"
        //   newtriedscope="ads_management,ads_read,pages_read_user_content,pages_manage_ads,pages_manage_engagement,pages_show_list,leads_retrieval,pages_manage_metadata,pages_read_engagement,manage_pages"
          // onClick={componentClicked}
          onClick={componentClicked}
          callback={componentClicked}
          textButton={
            <StyleFacebookButton>
              <i className="ri-links-line"></i>{" "}
              {false ? "Connect With Facebook" : "Connect a page"}
            </StyleFacebookButton>
          }
        />
      </div>
    </FacebookPageWrap>
  );
};

export default FacebookIntegration;

const FacebookPageWrap = styled.div`
  && {
    height: 100%;
    width: 100%;
    padding: 1rem;
    display: flex;
    flex-direction: column;

    .pageTopbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 48px;
      width: 100%;
    }

    .ctaBox {
      display: flex;
      height: 40%;
      flex-direction: column;
      gap: 1.6rem;
      padding: 1rem;
      justify-content: center;
      align-items: center;
    }

    .companyLogo {
      width: 96px;
      height: 96px;
      border-radius: 50%;
      object-fit: contain;
      background-color: #f5f6f8;
      padding: 0.2rem;
    }

    .buttonBox {
      width: 280px !important;
      /* background-color: red; */
      display: flex;
      justify-content: center;
    }

    .ctaTitle {
      font-size: 1.2rem;
    }
    .kep-login-facebook {
      font-size: 14px;
      border: none;
      border-radius: 6px !important;
      background-color: #3654e3 !important;
      height: 40px;
      padding: 6px 12px !important;
      font-weight: 400;
      text-transform: inherit;
    }
  }
`;
